import UltMeta, { Meta } from "./UltMeta/index";

// 机构认证状态
class InstitutionState extends UltMeta {
    PENDING_APPROVE = new Meta(1, "待审核");
    REJECTED = new Meta(2, "已驳回");
    APPROVED = new Meta(3, "已通过");
}

export const INSTITUTION_STATE = new InstitutionState();

// 授权状态
class AuthorizationState extends UltMeta {
    NONE = new Meta(1, "--");
    UNAUTHORIZED = new Meta(2, "未授权");
    AUTHORIZED = new Meta(3, "已授权");
}

export const AUTHORIZATION_STATE = new AuthorizationState();

// 企业身份
class RoleType extends UltMeta {
    PURCHASE_CUSTOMER = new Meta(1, "采购客户");
    WAREHOUSE_CUSTOMER = new Meta(2, "仓储业务客户");
    WAREHOUSE_MANAGE_CUSTOMER = new Meta(5, "仓储管理客户");
    INVENTORY_MANAGEMENT = new Meta(3, "进销存企业");
    WAREHOUSE_SUPERVISION = new Meta(4, "仓储业务企业");
    WAREHOUSE_MANAGE_SUPERVISION = new Meta(6, "仓储管理企业");
    TRADE_CUSTOMER = new Meta(7, "贸易客户");
    // 链小云智能体是企业级功能权限，用于审核赋权和供应链端菜单显隐。
    LIAN_XIAO_YUN = new Meta(8, "链小云智能体");
}

export const ROLE_TYPE = new RoleType();

class Source extends UltMeta {
    PURCHASE_CUSTOMER = new Meta(1, "客户端");
    WAREHOUSE_CUSTOMER = new Meta(2, "供应链端");
}
export const SOURCE = new Source();
